<template>
  <el-dialog
      :width="screenWidth<=976.98?'85%':'710px'"
      append-to-body
      custom-class="noticeModal"
      :show-close="true"
      :visible.sync="dialogFormVisible"
      @closed="closedDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="true">
    <div class="content">
      <div class="content-text title">
        {{ helpDetailObj.title }}
      </div>
      <div class="content-text content" v-html="helpDetailObj.detail"></div>
      <div class="content-confirm">
        <el-button type="warning" round @click="confirm">Confirm</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "notice",
  data(){
    return{
      screenWidth:null,
      dialogFormVisible:false,
      helpDetailObj:{}
    }
  },
  methods:{
    init(obj,flag){
      this.helpDetailObj = {};
      this.helpDetailObj = obj;
      // ext1 = 1 显示  等于其他隐藏 flag>0 表示有车票
      if(flag==99){
        this.dialogFormVisible = true;
        return;
      }
      if(this.helpDetailObj.ext1=="1" && !sessionStorage.getItem("showOnce")&&flag>0){
        this.dialogFormVisible = true;
      }
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    },
    closedDialog(){
      sessionStorage.setItem("showOnce",true);
      this.helpDetailObj = {};
    },
    confirm(){
      this.dialogFormVisible = false;
    },
  },
  mounted(){
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss">
.el-dialog.noticeModal{
  border-radius: 20px;
  @media (max-width:576.98px) {
    margin-top:8vh;
  }
  .el-dialog__header{
    display:none;
  }
  .el-dialog__body{
    padding: 30px 34px;
  }
  .content{
    &-text{
      word-break: break-word;
      font-weight: bold;
      letter-spacing: normal;
      color:#000000;
      margin-bottom:30px;
    }
    .title{
      font-size:24px;
      margin-bottom: 15px;
    }
    .content{
      font-size:17px;
      div{
        &:not(:last-child){
          margin-bottom:10px;
        }
      }
    }
    .el-button.is-round {
      width: 40%;
      border-radius: 20px;
      padding: 17px 23px;
      //background-color: #EDB546!important;
      background-color: #43D98E!important;
      border-color: #43D98E!important;
      //border-color: #43D98E!important;
      @media (max-width:576.98px) {
        width:100%;
      }
    }
    &-confirm{
      text-align: center;
    }

  }
}
</style>